module.exports = __webpack_public_path__ + "static/media/check-double-solid-branco.61e0ab5e.svg";